module.exports = __webpack_public_path__ + "img/eg-4.902f3e59.jpg";